import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Copyright from '../Copyright';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { homeColor } from '../ColorCodes';
import {
  CONST_BUSINESS_MAIL,
  CONST_BUSINESS_PHONE,
  MENU_SERVICE_LIST,
  CONST_BUSINESS_NAME,
  CONST_SITE_LABEL
} from '../Helper';
import { Button, Grid } from '@mui/material';
import { ChatbotChild } from './ChatbotChild.';
import DebugService from '../../../services/DebugService';
import { CONST_ROUTE_PATH } from '../../../route/RouteConstants';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate()

  const footerMenus = [
    // { label: 'About', path: CONST_ROUTE_PATH.ABOUT },
    // { label: 'Products', path: CONST_ROUTE_PATH.PRODUCTS },
    // { label: 'Services', path: CONST_ROUTE_PATH.SERVICES },
    { label: 'Pricing', path: CONST_ROUTE_PATH.PRICING },
    { label: 'Cloud Estimator', path: CONST_ROUTE_PATH.CLOUD_ESTIMATOR },
    // { label: 'Contact us', path: CONST_ROUTE_PATH.CONTACT_US },
  ]

  const [showChatbot, setShowChatbot] = useState(true)
  const [ShowAppointmentBookingSection, setShowAppointmentBookingSection] = useState(true)

  /**
   * Page load handler
   */
  useEffect(() => {
    DebugService.log(`Current pathname ${location.pathname}`)

    const isShowChatOption = ![
      CONST_ROUTE_PATH.QUERY_LOGS,
      CONST_ROUTE_PATH.TERMS_CONDITIONS,
      CONST_ROUTE_PATH.PRIVACY_POLICY,
      CONST_ROUTE_PATH.REFUND_POLICY,
    ].includes(location.pathname)
    setShowChatbot(isShowChatOption)

    const isShowAppointmentBookingSection = ![
      CONST_ROUTE_PATH.SCHEDULE_MEETING,
      CONST_ROUTE_PATH.QUERY_LOGS,
      CONST_ROUTE_PATH.TERMS_CONDITIONS,
      CONST_ROUTE_PATH.PRIVACY_POLICY,
      CONST_ROUTE_PATH.REFUND_POLICY,
    ].includes(location.pathname)
    setShowAppointmentBookingSection(isShowAppointmentBookingSection)
  }, [])

  return (
    <>
      {showChatbot && <ChatbotChild style={{}} />}

      <div className='footer'>
        {ShowAppointmentBookingSection && (
          <div style={{
            backgroundColor: '#2793F2',
          }}>
            <div className='home-section-book-appointment'>
              <Typography variant='h5' color={'#fff'} fontWeight={'600'}>Ready to get started?</Typography>
              <Typography variant='subtitle2' color={'#fff'} style={{ padding: '2vw' }}>See what your team can do with the most comprehensive AI-powered DevSecOps platform.</Typography>

              <Button className='btn-book-appointment'
                onClick={() => navigate(CONST_ROUTE_PATH.SCHEDULE_MEETING)}
                variant="contained">Book An Appointment Today!
              </Button>
            </div>
            <div><img
              style={{
                // backgroundColor: '#2793F2',
                width: '100%'
              }}
              src={`/cloud-background.png`}
              alt={''}
            // width={49}
            // height={170}
            /></div>
          </div>
        )}

        {/* Footer */}
        <Grid container spacing={2} className='footer-container'>

          <Grid item xs={12} sm={3}>
            <div><img src={`/${CONST_SITE_LABEL}-logo.png`} alt={CONST_BUSINESS_NAME} style={{
              width: '150px'
            }} /></div>
            <div className='footer-social-links'>
              <img src='/fb-icon.svg' alt={'Facebook'} width={'37'} height={'37'} />
              <img src='/instagram-icon.svg' alt={'Instagram'} width={'37'} height={'37'} />
              <img src='/linkedin-icon.svg' alt={'LinkedIn'} width={'37'} height={'37'} />
            </div>
          </Grid>

          {/* <Grid item container spacing={1} xs={12} md={6}> */}
            {/* <Grid item xs={6} sm={3}>
              <Typography variant='body2' style={{
                marginBottom: '0.6vw',
                color: '#FFF',
                fontWeight: '600'
              }}>Company</Typography>
              <div className='footer-menu'>
                {footerMenus.map((menu, i) => (
                  <Link to={menu.path} key={i}>
                    <Typography variant='body2' style={{
                      color: homeColor.footerlink,
                    }}>{menu.label}</Typography>
                  </Link>
                ))}
              </div>
            </Grid> */}
            {/* <Grid item xs={4} style={{ textAlign: 'left' }}>
              <Typography variant='body2' style={{
                marginBottom: '0.6vw',
                color: '#FFF',
                fontWeight: '600'
              }}>Services Offer</Typography>
              <div className='footer-menu'>
                {MENU_SERVICE_LIST.map((item, i) => (
                  <Link to={item.path} key={i}>
                    <Typography variant='body2' style={{
                      color: homeColor.footerlink,
                    }}>{item.label}</Typography>
                  </Link>
                ))}
              </div>
            </Grid> */}
            <Grid item xs={6} sm={3} style={{ textAlign: 'left' }}>
              <Typography variant='body2' style={{
                marginBottom: '0.6vw',
                color: '#FFF',
                fontWeight: '600'
              }}>Resources</Typography>
              <div className='footer-menu'>
                <Link to={CONST_ROUTE_PATH.TERMS_CONDITIONS}>
                  <Typography variant='body2' style={{
                    color: homeColor.footerlink,
                  }}>Terms and Conditions</Typography>
                </Link>
                <Link to={CONST_ROUTE_PATH.PRIVACY_POLICY}>
                  <Typography variant='body2' style={{
                    color: homeColor.footerlink,
                  }}>Privacy Policy</Typography>
                </Link>
                <Link to={CONST_ROUTE_PATH.REFUND_POLICY}>
                  <Typography variant='body2' style={{
                    color: homeColor.footerlink,
                  }}>Refund Policy</Typography>
                </Link>
              </div>
            </Grid>
          {/* </Grid> */}

          <Grid item xs={12} sm={3} style={{ textAlign: 'left' }}>
            <Typography variant='body2' color={'#fff'} style={{ display: 'flex', paddingBottom: '5px' }}>
              <img src='/phone-call-icon.svg' alt={'Phone Number'} width={'20'} height={'20'} />&nbsp;{CONST_BUSINESS_PHONE}
            </Typography>
            <Typography variant='body2' color={'#fff'} style={{ display: 'flex', paddingBottom: '5px' }}>
              <img src='/email-icon.svg' alt={'Email Address'} width={'20'} height={'20'} />&nbsp;{CONST_BUSINESS_MAIL}
            </Typography>
          </Grid>

        </Grid>

        {/* Footer copyright */}
        <div className='footer-copyright'>
          {/* <Typography variant="body2" style={{color: homeColor.subtext}}> */}
          <Copyright />
          {/* </Typography> */}
        </div>
      </div>
    </>
  );
};

export default Footer;
